export interface KeyDownFilterOptions {
  allowedKeys?: string[];
  allowPasteShortcut?: boolean;
  onInvalid?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const isPasteShortcut = (event: React.KeyboardEvent<HTMLInputElement>): boolean => {
  return (event.ctrlKey || event.metaKey) && (event.key === 'v' || event.key === 'V');
};

export const defaultAllowedKeys: string[] = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];

export function createKeyDownFilter(allowedPattern: RegExp, options?: KeyDownFilterOptions) {
  const { allowedKeys = defaultAllowedKeys, allowPasteShortcut = true, onInvalid } = options ?? {};

  return function keyDownFilter(event: React.KeyboardEvent<HTMLInputElement>): void {
    if (allowPasteShortcut && isPasteShortcut(event)) {
      return;
    }

    if (allowedKeys.includes(event.key)) {
      return;
    }

    if (!allowedPattern.test(event.key)) {
      onInvalid?.(event);
      event.preventDefault();
    }
  };
}
